import * as Sentry from '@sentry/browser'
import { createStore, applyMiddleware, combineReducers } from 'redux'
import { connectRoutes } from 'redux-first-router'
import restoreScroll from 'redux-first-router-restore-scroll'
import { composeWithDevTools } from '@redux-devtools/extension'
import createSagaMiddleware from 'redux-saga'
import queryString from 'query-string'

import * as routes from 'ducks/router'
import reducers from './reducer'
import rootSaga from './sagas'

const PRODUCTION = process.env.PRODUCTION

const configureStore = (initialState = {}, routeHistory = []) => {
  const router = connectRoutes(routes.routesMap, {
    initialDispatch: false,
    initialEntries: routeHistory,
    restoreScroll: restoreScroll(),
    querySerializer: {
      parse: query => queryString.parse(query, { arrayFormat: 'comma' }),
      stringify: params =>
        queryString.stringify(params, { arrayFormat: 'comma' }),
    },
  })
  const sagaMiddleware = createSagaMiddleware({
    onError: PRODUCTION ? Sentry.captureException : console.error,
  })
  const middlewares = [router.middleware, sagaMiddleware]
  const composeEnhancers = composeWithDevTools({
    actionsDenylist: ['timer/UPDATE_TIMER'],
    trace: true,
  })
  const enhancers = composeEnhancers(
    router.enhancer,
    applyMiddleware(...middlewares),
  )
  const rootReducer = combineReducers({
    [routes.SLICE]: router.reducer,
    ...reducers,
  })
  const store = createStore(rootReducer, initialState, enhancers)
  let sagaTask = sagaMiddleware.run(rootSaga)

  router.initialDispatch()

  if (module.hot) {
    module.hot.accept('./reducer', () => {
      const reducers = require('./reducer').default
      const newReducer = combineReducers({
        [routes.SLICE]: router.reducer,
        ...reducers,
      })
      store.replaceReducer(newReducer)
    })
    // Hot module replacement for saga
    module.hot.accept('./sagas/', () => {
      sagaTask.cancel() // stop old saga
      sagaTask.done.then(() => {
        sagaTask = sagaMiddleware.run(require('./sagas/').default)
      })
    })
  }
  return store
}

export default configureStore
